module dg.objects {

    export class DateRangeDisplayerController extends PropertyDisplayerControllerBase<dg.domain.model.Range<any>> {

        public formattedValue: any;
        private dateFormat: string;
        public tooltipTitle: string;

        public constructor(
            private $filter: ng.IFilterService,
            private dateService: DateService,
            private customDateRangeService: CustomDateRangeService
        ) {
            super();

            this.dateFormat = dateService.getFormat(dg.restfulApi.DG_DATA_TYPES.Date)
        }

        $onChanges = (changes) => {
            if (changes.value.previousValue !== changes.value.currentValue) {
                this.tooltipTitle = '';

                let minDate = new Date(this.value.min);
                let maxDate = new Date(this.value.max);

                let minDateFormatted = this.$filter('date')(minDate, this.dateFormat),
                    maxDateFormatted = this.$filter('date')(maxDate, this.dateFormat);

                let periodRange = this.customDateRangeService.getPeriodByRange(minDate, maxDate);

                this.formattedValue = minDateFormatted + " - " + maxDateFormatted;
                if (periodRange) {
                    this.tooltipTitle = this.formattedValue;
                    this.formattedValue = periodRange.title;
                }

            }
        }
    }

    dg.objects.AngularHelper.registerPropertyDisplayer(DateRangeDisplayerController, 'dateRangeDisplayer', {
        template: '<span uib-tooltip="{{$ctrl.tooltipTitle}}" ng-bind="$ctrl.formattedValue"></span>'
    });
    //angular.module('dg.objects')

    //    .component('dateRangeDisplayer', {
    //        bindings: {
    //            value: '<'
    //        },
    //        controller: DateRangeDisplayerController,
    //        template: '<span ng-bind="$ctrl.formattedValue"></span>',
    //    });
}
